// ----------------------------------------------------------------------
// <copyright file="Izenda.ChartGridLinesSettingsAxis.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
//</copyright>
// ----------------------------------------------------------------------

!(function() {

  var React = require('react');
  var EventUtils = require('EventUtils');
  var Input = require('share/components/controls/Izenda.Input');
  var ColorPicker = require('share/components/controls/Izenda.ColorPicker');
  var DashStyle = require('share/components/controls/Izenda.DashStyle');
  var Thickness = require('share/components/controls/Izenda.Thinkness');
  var CONSTANTS = require('logic/data/Izenda.ReportPartChartConstants').CHART_SETTINGS.DEFAULT_VALUE;
  var localizer = require('share/localization/Izenda.Localizer');

  var ChartGridLinesSettingsAxis = React.createClass({

    getInitialState: function () {
      var value = this.props.value;
      return {
        visible: value.visible,
        lineWidth: value.lineWidth || 1,
        lineColor: value.lineColor || CONSTANTS.BLACK_COLOR,
        lineDashStyle: value.lineDashStyle || CONSTANTS.DASH_STYLE
      };
    },

    changeState: function (key, value) {
      var obj = {};
      obj[key] = value;
      this.setState(obj, function () {
        this.props.onChange({value: this.state});
      }.bind(this));
    },

    handleVisibleChanged: function (newValue) {
      this.changeState('visible', newValue);
    },

    handleLineColorChanged: function (newValue) {
      this.changeState('lineColor', newValue);
    },

    handleChangeDashStyle: function (newValue) {
      this.changeState('lineDashStyle', newValue);
    },

    handleThicknessChanged: function (thickness) {
      this.changeState('lineWidth', thickness.value);
    },

    render: function () {

      var state = this.state;

      return (
          <div className="grid-line-settings-axis">
            <div className="row visible">
              <span className="col-md-4">{localizer.getText("COMMON_LABEL_VISIBLE")}</span>
              <Input type="checkbox" checked={state.visible}
                     onChange={EventUtils.notifyChange(this.handleVisibleChanged, EventUtils.CHECKBOX)} />
            </div>
            <div className="row color">
              <span className="col-md-4">{localizer.getText("COMMON_LABEL_COLOR")}</span>
              <div className="col-md-8">
                <ColorPicker disabled={!state.visible}
                             color={state.lineColor}
                             type="photoshop"
                             onChange={this.handleLineColorChanged} />
              </div>
            </div>
            <div className="row style">
              <span className="col-md-4">{localizer.getText("BORDER_SETTING_LABEL_DASH_STYLE")}</span>
              <div className="col-md-8">
                <DashStyle dashStyle={state.lineDashStyle}
                           disabled={!state.visible}
                           onChange={this.handleChangeDashStyle} />
              </div>
            </div>
            <div className="row thickness">
              <span className="col-md-4">{localizer.getText("BORDER_SETTING_LABEL_THICKNESS")}</span>
              <div className="col-md-8">
                <Thickness value={state.lineWidth}
                           disabled={!state.visible}
                           onChange={this.handleThicknessChanged} />
              </div>
            </div>
          </div>
      )
    }

  });

  module.exports = ChartGridLinesSettingsAxis;

}());



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/PropertiesBuilder/ChartSettings/Izenda.ChartGridLinesSettingsAxis.jsx